import './styles.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LayoutContainer from 'Components/LayoutComponent'

const EditCoffeeCastEpisode = () => {
  const { t } = useTranslation()

  return (
    <LayoutContainer title={t('EDIT_COFFEE_CAST')} breadCrumbsTitle={'editCoffeeCast'}>
      <div className="coffee-cast-episode-edit-form"></div>
    </LayoutContainer>
  )
}

export default EditCoffeeCastEpisode
